import { render } from "./Producto.vue?vue&type=template&id=79cf2573"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"
script.render = render

export default script